<div class="overdiv">
    <div class="welcomeText">
        <h3>{{dataJson["Ueberschrift"]}} <span style="font-weight: 500;">{{dataJson["UeberschriftStyle"]}}</span></h3>
        <div class="wrap">
            <div class="card" data-aos="fade-up">
                <img src="./assets/img/Physiotherapie.webp" alt="">
                <div>
                    <h4>{{dataJson["Block1Ueberschrift"]}}</h4>
                    <span>{{dataJson["Block1Text1"]}} <b>{{dataJson["Block1TextDick"]}}</b> {{dataJson["Block1Text2"]}}</span>
                </div>
                <div style="margin: 16px;" class="TeamButton">
                    <a aria-label="Mehr zu Physiotherapie" routerLink="/physiotherapie">{{dataJson["Block1Button"]}}</a>
                </div>
            </div>
            <div class="card" data-aos="fade-up">
                <img src="./assets/img/Osteopathie.webp" alt="">
                <div>
                    <h4>{{dataJson["Block2Ueberschrift"]}}</h4>
                    <span>{{dataJson["Block2Text1"]}} <b>{{dataJson["Block2TextDick"]}}</b> {{dataJson["Block2Text2"]}}</span>
                </div>
                <div style="margin: 16px;" class="TeamButton">
                    <a aria-label="Mehr zu Osteopathie" routerLink="/osteopathie">{{dataJson["Block2Button"]}}</a>
                </div>
            </div>
            <div class="card" data-aos="fade-up">
                <img src="./assets/img/Naturheilpraxis.webp" alt="">
                <div>
                    <h4>{{dataJson["Block3Ueberschrift"]}}</h4>
                    <span>{{dataJson["Block3Text1"]}} <b>{{dataJson["Block3TextDick"]}}</b> {{dataJson["Block3Text2"]}}</span>
                </div>
                <div style="margin: 16px;" class="TeamButton">
                    <a aria-label="Mehr zu Heilkunde" routerLink="/heilkunde">{{dataJson["Block3Button"]}}</a>
                </div>
            </div>
        </div>
        
    </div>    
    <app-contact-pre></app-contact-pre>
</div>

